import isEmpty from "lodash/isEmpty";

export const siftActivities = (activities, input) => {
  return new Promise((resolve, reject) => {
    const { items } = new window.Sifter(activities).search(input, {
      fields: ['dropdown', 'display_keyword', 'use-subtype', 'display_use_type'],
      limit: 5,
      conjunction: 'and'
    });
    if (!isEmpty(items)) {
      const mapSiftedActivities = items.map((item) => ({
        label: activities[item.id].dropdown,
        value: activities[item.id]
      }));
      return resolve(mapSiftedActivities);
    }
    return reject();
  });
};
